"use client"
import React from 'react';
import { StarIcon } from "@heroicons/react/24/solid";
import QrCode from "../qr-code/QrCode";
import {GoogleDetails} from "../../../types";

type GoogleReviewsProps = {
    buttonTitle?:string;
    googleDetails:GoogleDetails;
    hideStars?:boolean;
    showQRCode?:boolean;
}

const GoogleReviews = ({
                           buttonTitle,
                           googleDetails,
                           hideStars = false,
                           showQRCode = true,
}: GoogleReviewsProps) => {

    const {googleReviewLink} = googleDetails

    if (!googleReviewLink) {
        return null;
    }

    return (
        <div className="py-2">
            {!hideStars && (
            <div>
                <div className="flex gap-2 pb-6 mx-auto max-w-max">
                    {Array.from({length: 5}).map((_, index) => (
                        <StarIcon key={index} className="text-[#ffb300] w-[38px] h-[38px]"/>
                    ))}
                </div>
            </div>
            )}
            {showQRCode && (<div>
                <QrCode value={googleReviewLink} size={200}/>
            </div>)}
            {!!buttonTitle?.length && (<div className="pt-5 pb-10 mx-auto max-w-max">
                <a
                    href={googleReviewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Leave a review on Google"
                    className="
                        w-4/5 sm:w-auto
                        inline-block
                        bg-blue-600 hover:bg-blue-700
                        text-white font-medium
                        px-4 py-2
                        rounded
                        transition-colors
                        text-center
                      "
                >
                    {buttonTitle}
                </a>
            </div>
            )}
        </div>
    );
};

export default GoogleReviews;
